import Content from "../../help/lot-feed-sessions.mdx";

export function LotFeedSessionsHelpPage() {
  return <Content />;
}
